<template>
  <div class="college-manage">
    <el-card>
      <div slot="header" class="card-header">
        <span class="title">学校管理</span>
        <div>
          <el-upload
            ref="importUpload"
            :action="importUrl"
            :http-request="handleImport"
            :show-file-list="false"
            :before-upload="beforeImportUpload"
            accept=".xlsx,.xls"
            style="display: inline-block; margin-right: 10px;">
            <el-button type="success" icon="el-icon-upload2">一键导入专业</el-button>
          </el-upload>
          <el-button 
            type="danger" 
            icon="el-icon-delete" 
            :disabled="selectedRows.length === 0"
            @click="handleBatchDelete"
            style="margin-right: 10px;">
            批量删除
          </el-button>
           <el-button type="primary" icon="el-icon-plus" @click="handleAdd">添加学校</el-button>
        </div>
      </div>
      
      <!-- 搜索栏 -->
      <div style="margin-bottom: 20px;">
        <el-input
          v-model="searchKeyword"
          placeholder="请输入学校名称搜索"
          style="width: 300px; margin-right: 10px;"
          clearable
          @clear="handleSearch"
          @keyup.enter.native="handleSearch">
          <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
        </el-input>
      </div>
      
      <el-table 
        :data="tableData" 
        style="width: 100%" 
        border 
        stripe
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" align="center"/>
        <el-table-column label="学校图片" width="120">
          <template slot-scope="scope">
            <el-image 
              v-if="getDisplayImage(scope.row)"
              :src="getImageUrl(getDisplayImage(scope.row))" 
              :preview-src-list="getPreviewImages(scope.row)"
              style="width: 80px; height: 60px"
              fit="cover">
            </el-image>
            <span v-else style="color: #999">暂无图片</span>
          </template>
        </el-table-column>
        <el-table-column prop="collegeName" label="学校名称" width="180"/>
        <el-table-column prop="collegeLevel" label="学校层次" width="100"/>
        <el-table-column prop="collegeCategory" label="学校类别" width="100"/>
        <el-table-column prop="collegeIntro" label="学校介绍" show-overflow-tooltip/>
        <el-table-column label="操作" width="200" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button size="small" type="primary" icon="el-icon-edit" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="small" type="danger" icon="el-icon-delete" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="pageSizes"
        :page-size="pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin-top: 20px; text-align: right;">
      </el-pagination>
      
      <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="1000px" :close-on-click-modal="false" custom-class="college-dialog">
        <el-tabs v-model="activeTab">
          <!-- 基本信息标签页 -->
          <el-tab-pane label="基本信息" name="basic">
            <div class="tab-content">
            <el-form :model="form" :rules="rules" ref="form" label-width="100px">
              <el-form-item label="学校名称" prop="collegeName">
                <el-input v-model="form.collegeName" placeholder="请输入学校名称"/>
              </el-form-item>

              <el-form-item label="学校层次" prop="collegeLevel">
                <el-select v-model="form.collegeLevel" placeholder="请选择学校层次" style="width: 100%">
                  <el-option 
                    v-for="item in collegeLevelOptions" 
                    :key="item.dictCode" 
                    :label="item.dictValue" 
                    :value="item.dictValue"/>
                </el-select>
              </el-form-item>

              <el-form-item label="学校类别" prop="collegeCategory">
                <el-select v-model="form.collegeCategory" placeholder="请选择学校类别" style="width: 100%">
                  <el-option 
                    v-for="item in collegeCategoryOptions" 
                    :key="item.dictCode" 
                    :label="item.dictValue" 
                    :value="item.dictValue"/>
                </el-select>
              </el-form-item>

              <el-form-item label="学校介绍" prop="collegeIntro">
                <el-input 
                  v-model="form.collegeIntro" 
                  type="textarea" 
                  :rows="5"
                  placeholder="请输入学校介绍"/>
              </el-form-item>

              <el-form-item label="学校图标">
                <el-upload
                  class="icon-uploader"
                  :action="uploadUrl"
                  :show-file-list="false"
                  :on-success="handleIconUploadSuccess"
                  :before-upload="beforeUpload"
                  accept="image/*">
                  <img v-if="form.collegeIcon" :src="getImageUrl(form.collegeIcon)" class="icon-preview">
                  <i v-else class="el-icon-plus icon-uploader-icon"></i>
                  <div slot="tip" class="el-upload__tip">建议上传正方形图标，不超过2MB</div>
                </el-upload>
              </el-form-item>

              <el-form-item label="学校图片">
                <el-upload
                  class="upload-demo"
                  :action="uploadUrl"
                  :on-success="handleUploadSuccess"
                  :on-error="handleUploadError"
                  :before-upload="beforeUpload"
                  :file-list="fileList"
                  :on-remove="handleRemove"
                  list-type="picture-card"
                  accept="image/*"
                  multiple>
                  <i class="el-icon-plus"></i>
                  <div slot="tip" class="el-upload__tip">支持上传多张图片，每张不超过2MB</div>
                </el-upload>
              </el-form-item>
            </el-form>
            </div>
          </el-tab-pane>

          <!-- 专升本专业标签页 -->
          <el-tab-pane label="专升本专业" name="major">
            <div class="tab-content">
            <el-button type="primary" size="small" @click="handleAddMajor" style="margin-bottom: 10px">添加专业</el-button>
            <el-table :data="form.majors" border style="width: 100%">
              <el-table-column prop="majorName" label="专业名称" width="150"></el-table-column>
              <el-table-column prop="receiveMajor" label="接收专业" width="150"></el-table-column>
              <el-table-column prop="enrollmentCount" label="招生计划" width="100"></el-table-column>
              <el-table-column prop="tuitionFee" label="学费(元/年)" width="120"></el-table-column>
              <el-table-column prop="examSubjects" label="考试科目" min-width="150"></el-table-column>
<!--              <el-table-column prop="enrollmentPlan" label="招生计划" min-width="150"></el-table-column>-->
              <el-table-column label="操作" width="150" fixed="right">
                <template slot-scope="scope">
                  <el-button size="mini" @click="handleEditMajor(scope.$index, scope.row)">编辑</el-button>
                  <el-button size="mini" type="danger" @click="handleDeleteMajor(scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            </div>
          </el-tab-pane>

          <!-- 专升本分数线标签页 -->
          <el-tab-pane label="专升本分数线" name="scoreLine">
            <div class="tab-content">
            <el-button type="primary" size="small" @click="handleAddScoreLine" style="margin-bottom: 10px">添加分数线</el-button>
            <el-table :data="form.scoreLines" border style="width: 100%">
              <el-table-column prop="year" label="年度" width="120"></el-table-column>
              <el-table-column prop="majorName" label="专业名称" width="200"></el-table-column>
              <el-table-column prop="score" label="分数" width="120"></el-table-column>
              <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                  <el-button size="mini" @click="handleEditScoreLine(scope.$index, scope.row)">编辑</el-button>
                  <el-button size="mini" type="danger" @click="handleDeleteScoreLine(scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            </div>
          </el-tab-pane>
        </el-tabs>

        <span slot="footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleSubmit">确定</el-button>
        </span>
      </el-dialog>

      <!-- 专业编辑对话框 -->
      <el-dialog title="专业信息" :visible.sync="majorDialogVisible" width="600px" append-to-body :close-on-click-modal="false">
        <el-form :model="majorForm" label-width="100px">
          <el-form-item label="专业名称">
            <el-input v-model="majorForm.majorName" placeholder="请输入专业名称"></el-input>
          </el-form-item>
          <el-form-item label="接收专业">
            <el-input v-model="majorForm.receiveMajor" placeholder="请输入接收专业（对应的专科专业）"></el-input>
          </el-form-item>
          <el-form-item label="招生人数">
            <el-input-number v-model="majorForm.enrollmentCount" :min="0" placeholder="请输入招生人数"></el-input-number>
          </el-form-item>
          <el-form-item label="学费(元/年)">
            <el-input-number v-model="majorForm.tuitionFee" :min="0" :precision="2" placeholder="请输入学费"></el-input-number>
          </el-form-item>
          <el-form-item label="考试科目">
            <el-input v-model="majorForm.examSubjects" type="textarea" :rows="3" placeholder="请输入考试科目"></el-input>
          </el-form-item>
          <el-form-item label="招生计划">
            <el-input v-model="majorForm.enrollmentPlan" type="textarea" :rows="3" placeholder="请输入招生计划"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer">
          <el-button @click="majorDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleMajorSubmit">确定</el-button>
        </span>
      </el-dialog>

      <!-- 分数线编辑对话框 -->
      <el-dialog title="分数线信息" :visible.sync="scoreLineDialogVisible" width="500px" append-to-body :close-on-click-modal="false">
        <el-form :model="scoreLineForm" label-width="100px">
          <el-form-item label="年度">
            <el-input v-model="scoreLineForm.year" placeholder="请输入年度，如：2024"></el-input>
          </el-form-item>
          <el-form-item label="专业名称">
            <el-input v-model="scoreLineForm.majorName" placeholder="请输入专业名称"></el-input>
          </el-form-item>
          <el-form-item label="分数">
            <el-input-number v-model="scoreLineForm.score" :min="0" :max="1000" :precision="2" placeholder="请输入分数"></el-input-number>
          </el-form-item>
        </el-form>
        <span slot="footer">
          <el-button @click="scoreLineDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleScoreLineSubmit">确定</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import collegeApi from '../api/college'
import dictApi from '../api/dict'
import upgradeMajorApi from '../api/upgradeMajor'
import upgradeScoreLineApi from '../api/upgradeScoreLine'

export default {
  name: 'CollegeManage',
  data() {
    return {
      tableData: [],
      dialogVisible: false,
      dialogTitle: '添加学校',
      uploadUrl: '/api/college/upload',
      importUrl: '/api/college/import-major',
      activeTab: 'basic',
      form: {
        collegeName: '',
        collegeLevel: '',
        collegeCategory: '',
        collegeIntro: '',
        collegeIcon: '',
        collegeImages: [],
        majors: [],
        scoreLines: []
      },
      rules: {
        collegeName: [
          { required: true, message: '请输入学校名称', trigger: 'blur' }
        ]
      },
      fileList: [],
      isEdit: false,
      collegeLevelOptions: [],
      collegeCategoryOptions: [],
      majorDialogVisible: false,
      majorForm: {
        majorName: '',
        receiveMajor: '',
        enrollmentCount: null,
        tuitionFee: null,
        examSubjects: '',
        enrollmentPlan: ''
      },
      majorEditIndex: -1,
      scoreLineDialogVisible: false,
      scoreLineForm: {
        year: '',
        majorName: '',
        score: null
      },
      scoreLineEditIndex: -1,
      // 分页相关
      currentPage: 1,
      pageSize: 10,
      total: 0,
      pageSizes: [5, 10, 20, 50],
      // 批量删除相关
      selectedRows: [],
      // 搜索关键字
      searchKeyword: ''
    }
  },
  mounted() {
    this.loadData()
    this.loadDictData()
  },
  methods: {
    async loadData() {
      try {
        const res = await collegeApi.getList(this.currentPage, this.pageSize, this.searchKeyword)
        if (res.data.code === 200) {
          // 处理JSON字符串字段
          this.tableData = res.data.data.map(item => ({
            ...item,
            collegeImages: this.parseJSON(item.collegeImages)
          }))
          this.total = res.data.total || 0
        }
      } catch (error) {
        this.$message.error('加载数据失败')
      }
    },
    async loadDictData() {
      try {
        // 加载学校层次字典
        const levelRes = await dictApi.listByType('college_level')
        if (levelRes.data.code === 200) {
          // 新版API返回的是 DictData 对象，需要映射为 dataValue
          this.collegeLevelOptions = levelRes.data.data.map(item => item.dataValue)
        }
        
        // 加载学校类别字典
        const categoryRes = await dictApi.listByType('college_category')
        if (categoryRes.data.code === 200) {
          // 新版API返回的是 DictData 对象，需要映射为 dataValue
          this.collegeCategoryOptions = categoryRes.data.data.map(item => item.dataValue)
        }
      } catch (error) {
        console.error('加载字典数据失败', error)
      }
    },
    parseJSON(str) {
      if (!str) return []
      try {
        return typeof str === 'string' ? JSON.parse(str) : str
      } catch (e) {
        return []
      }
    },
    // 获取要显示的图片（优先显示 collegeIcon，其次显示 collegeImages 第一张）
    getDisplayImage(row) {
      // 优先显示学校图标
      if (row.collegeIcon) {
        return row.collegeIcon
      }
      // 其次显示学校图片列表的第一张
      const images = Array.isArray(row.collegeImages) ? row.collegeImages : []
      return images.length > 0 ? images[0] : null
    },
    // 获取预览图片列表（包含图标和所有图片）
    getPreviewImages(row) {
      const previewList = []
      
      // 添加学校图标
      if (row.collegeIcon) {
        previewList.push(this.getImageUrl(row.collegeIcon))
      }
      
      // 添加学校图片列表
      const images = Array.isArray(row.collegeImages) ? row.collegeImages : []
      images.forEach(img => {
        previewList.push(this.getImageUrl(img))
      })
      
      return previewList
    },
    getFirstImage(row) {
      const images = Array.isArray(row.collegeImages) ? row.collegeImages : []
      return images.length > 0 ? images[0] : null
    },
    getImageList(row) {
      const images = Array.isArray(row.collegeImages) ? row.collegeImages : []
      return images.map(img => this.getImageUrl(img))
    },
    getImageUrl(path) {
      if (!path) return ''
      
      // 如果已经是完整URL（http或https开头），直接返回
      if (path.startsWith('http://') || path.startsWith('https://')) {
        return path
      }
      
      // 相对路径处理：直接拼接 API 基础URL
      if (path.startsWith('/uploads/')) {
        return `${process.env.VUE_APP_API_BASE_URL}${path}`
      }
      
      // 其他情况直接拼接
      return `${process.env.VUE_APP_API_BASE_URL}${path}`
    },
    getImageUrlWithHeaders(path) {
      const url = this.getImageUrl(path)
      return url
    },
    beforeUpload(file) {
      const isImage = file.type.startsWith('image/')
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isImage) {
        this.$message.error('只能上传图片文件!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
        return false
      }
      return true
    },
    handleIconUploadSuccess(response) {
      if (response.code === 200) {
        this.form.collegeIcon = response.data
        this.$message.success('图标上传成功')
      } else {
        this.$message.error(response.message || '图标上传失败')
      }
    },
    handleUploadSuccess(response, file, fileList) {
      if (response.code === 200) {
        this.form.collegeImages.push(response.data)
        this.fileList = fileList
        this.$message.success('上传成功')
      } else {
        this.$message.error(response.message || '上传失败')
      }
    },
    handleRemove(file, fileList) {
      const index = this.fileList.findIndex(f => f.uid === file.uid)
      if (index > -1) {
        this.form.collegeImages.splice(index, 1)
      }
      this.fileList = fileList
    },
    handleUploadError() {
      this.$message.error('上传失败，请重试')
    },
    handleAdd() {
      this.dialogTitle = '添加学校'
      this.isEdit = false
      this.activeTab = 'basic'
      this.form = {
        collegeName: '',
        collegeLevel: '',
        collegeCategory: '',
        collegeIntro: '',
        collegeIcon: '',
        collegeImages: [],
        majors: [],
        scoreLines: []
      }
      this.fileList = []
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },
    async handleEdit(row) {
      this.dialogTitle = '编辑学校'
      this.isEdit = true
      this.activeTab = 'basic'
      
      // 深拷贝并处理数据，确保 id 被正确保存
      this.form = {
        id: row.id,  // 明确保存 id
        collegeName: row.collegeName,
        collegeLevel: row.collegeLevel,
        collegeCategory: row.collegeCategory,
        collegeIntro: row.collegeIntro,
        collegeIcon: row.collegeIcon || '',
        collegeImages: Array.isArray(row.collegeImages) ? [...row.collegeImages] : [],
        majors: [],
        scoreLines: []
      }
      
      // 处理图片列表回显
      if (this.form.collegeImages.length > 0) {
        this.fileList = this.form.collegeImages.map((url, index) => ({
          uid: index,
          name: `image-${index}`,
          url: this.getImageUrl(url)
        }))
      } else {
        this.fileList = []
      }
      
      // 只加载该学校的专业列表（性能优化）
      try {
        const majorRes = await upgradeMajorApi.getByCollege(row.id)
        if (majorRes.data.code === 200) {
          this.form.majors = majorRes.data.data || []
        }
      } catch (error) {
        console.error('加载专业列表失败', error)
      }
      
      // 只加载该学校专业的分数线（性能优化）
      try {
        if (this.form.majors.length > 0) {
          // 直接传递专业名称数组，避免 URL 过长
          const majorNames = this.form.majors.map(m => m.majorName).filter(name => name)
          const scoreRes = await upgradeScoreLineApi.getByMajors(majorNames)
          if (scoreRes.data.code === 200) {
            this.form.scoreLines = scoreRes.data.data || []
          }
        }
      } catch (error) {
        console.error('加载分数线列表失败', error)
      }
      
      this.dialogVisible = true
    },
    async handleSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            // 准备提交数据，将数组转为JSON字符串
            const submitData = {
              ...this.form,
              collegeImages: JSON.stringify(this.form.collegeImages)
            }
            
            // 调试：打印提交的数据
            console.log('提交数据:', submitData)
            console.log('是否编辑模式:', this.isEdit)
            console.log('学校ID:', submitData.id)
            
            let collegeId = this.form.id
            
            if (this.isEdit) {
              // 编辑模式：确保 id 存在
              if (!submitData.id) {
                this.$message.error('更新失败：学校ID不存在')
                return
              }
              await collegeApi.update(submitData)
              this.$message.success('更新成功')
            } else {
              const res = await collegeApi.add(submitData)
              if (res.data.code === 200 && res.data.data) {
                collegeId = res.data.data.id || res.data.data
              }
              this.$message.success('添加成功')
            }
            
            // 保存专业信息 - 只保存有变化的专业
            if (collegeId && this.form.majors.length > 0) {
              for (const major of this.form.majors) {
                // 如果专业有 _modified 标记，说明被修改过，才需要保存
                if (major._modified || !major.id) {
                  const majorData = {
                    ...major,
                    collegeId: collegeId,
                    collegeName: this.form.collegeName
                  }
                  // 删除标记字段，不提交到后端
                  delete majorData._modified
                  
                  if (major.id) {
                    await upgradeMajorApi.update(majorData)
                  } else {
                    await upgradeMajorApi.add(majorData)
                  }
                }
              }
            }
            
            // 保存分数线信息 - 只保存有变化的分数线
            if (this.form.scoreLines.length > 0) {
              for (const scoreLine of this.form.scoreLines) {
                // 如果分数线有 _modified 标记，说明被修改过，才需要保存
                if (scoreLine._modified || !scoreLine.id) {
                  const scoreLineData = { ...scoreLine }
                  // 删除标记字段，不提交到后端
                  delete scoreLineData._modified
                  
                  if (scoreLine.id) {
                    await upgradeScoreLineApi.update(scoreLineData)
                  } else {
                    await upgradeScoreLineApi.add(scoreLineData)
                  }
                }
              }
            }
            
            this.dialogVisible = false
            this.loadData()
          } catch (error) {
            this.$message.error('操作失败')
          }
        }
      })
    },
    // 专业管理方法
    handleAddMajor() {
      this.majorEditIndex = -1
      this.majorForm = {
        majorName: '',
        receiveMajor: '',
        enrollmentCount: null,
        tuitionFee: null,
        examSubjects: '',
        enrollmentPlan: ''
      }
      this.majorDialogVisible = true
    },
    handleEditMajor(index, row) {
      this.majorEditIndex = index
      this.majorForm = { ...row }
      this.majorDialogVisible = true
    },
    handleMajorSubmit() {
      if (this.majorEditIndex === -1) {
        // 添加 - 标记为新增
        this.form.majors.push({ ...this.majorForm, _modified: true })
      } else {
        // 编辑 - 标记为已修改
        this.$set(this.form.majors, this.majorEditIndex, { ...this.majorForm, _modified: true })
      }
      this.majorDialogVisible = false
    },
    async handleDeleteMajor(index) {
      const major = this.form.majors[index]
      if (major.id) {
        // 如果有ID，说明是已保存的，需要调用API删除
        try {
          await this.$confirm('确定删除该专业吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          await upgradeMajorApi.delete(major.id)
          this.$message.success('删除成功')
        } catch (error) {
          if (error !== 'cancel') {
            this.$message.error('删除失败')
          }
          return
        }
      }
      this.form.majors.splice(index, 1)
    },
    // 分数线管理方法
    handleAddScoreLine() {
      this.scoreLineEditIndex = -1
      this.scoreLineForm = {
        year: '',
        majorName: '',
        score: null
      }
      this.scoreLineDialogVisible = true
    },
    handleEditScoreLine(index, row) {
      this.scoreLineEditIndex = index
      this.scoreLineForm = { ...row }
      this.scoreLineDialogVisible = true
    },
    handleScoreLineSubmit() {
      if (this.scoreLineEditIndex === -1) {
        // 添加 - 标记为新增
        this.form.scoreLines.push({ ...this.scoreLineForm, _modified: true })
      } else {
        // 编辑 - 标记为已修改
        this.$set(this.form.scoreLines, this.scoreLineEditIndex, { ...this.scoreLineForm, _modified: true })
      }
      this.scoreLineDialogVisible = false
    },
    async handleDeleteScoreLine(index) {
      const scoreLine = this.form.scoreLines[index]
      if (scoreLine.id) {
        // 如果有ID，说明是已保存的，需要调用API删除
        try {
          await this.$confirm('确定删除该分数线吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          await upgradeScoreLineApi.delete(scoreLine.id)
          this.$message.success('删除成功')
        } catch (error) {
          if (error !== 'cancel') {
            this.$message.error('删除失败')
          }
          return
        }
      }
      this.form.scoreLines.splice(index, 1)
    },
    handleDelete(row) {
      this.$confirm('确定删除该学校吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await collegeApi.delete(row.id)
          this.$message.success('删除成功')
          this.loadData()
        } catch (error) {
          this.$message.error('删除失败')
        }
      })
    },
    beforeImportUpload(file) {
      const isExcel = file.name.endsWith('.xlsx') || file.name.endsWith('.xls')
      const isLt10M = file.size / 1024 / 1024 < 10

      if (!isExcel) {
        this.$message.error('只能上传Excel文件（.xlsx或.xls）!')
        return false
      }
      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过 10MB!')
        return false
      }
      return true
    },
    async handleImport(options) {
      const loading = this.$loading({
        lock: true,
        text: '正在导入，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      
      try {
        const res = await collegeApi.importMajor(options.file)
        loading.close()
        
        if (res.data.code === 200) {
          const { successCount, failCount, skipCount, errors, totalErrors } = res.data
          let message = `导入完成！成功：${successCount}条`
          
          if (skipCount > 0) {
            message += `，跳过空行：${skipCount}条`
          }
          
          if (failCount > 0) {
            message += `，失败：${failCount}条`
            if (errors && errors.length > 0) {
              // 显示详细错误信息
              const errorMsg = errors.join('\n')
              const totalMsg = totalErrors > errors.length ? `\n\n（共${totalErrors}条错误，仅显示前${errors.length}条）` : ''
              this.$alert(
                `${message}\n\n错误详情：\n${errorMsg}${totalMsg}`,
                '导入结果',
                {
                  confirmButtonText: '确定',
                  type: 'warning',
                  dangerouslyUseHTMLString: false
                }
              )
            } else {
              this.$message({
                message: message,
                type: 'warning',
                duration: 5000
              })
            }
          } else {
            this.$message.success(message)
          }
          
          // 刷新列表
          this.loadData()
        } else {
          this.$message.error(res.data.message || '导入失败')
        }
      } catch (error) {
        loading.close()
        console.error('导入失败', error)
        this.$message.error('导入失败：' + (error.message || '未知错误'))
      }
    },
    handleSelectionChange(selection) {
      this.selectedRows = selection
    },
    handleBatchDelete() {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请选择要删除的数据')
        return
      }
      
      this.$confirm(`确定删除选中的 ${this.selectedRows.length} 条数据吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const ids = this.selectedRows.map(row => row.id)
          await collegeApi.batchDelete(ids)
          this.$message.success('批量删除成功')
          this.loadData()
        } catch (error) {
          this.$message.error('批量删除失败')
        }
      }).catch(() => {
        // 用户取消
      })
    },
    handleSizeChange(size) {
      this.pageSize = size
      this.currentPage = 1
      this.loadData()
    },
    handleCurrentChange(page) {
      this.currentPage = page
      this.loadData()
    },
    // 搜索功能
    handleSearch() {
      this.currentPage = 1  // 搜索时重置到第一页
      this.loadData()
    }
  }
}
</script>

<style scoped>
.college-manage {
  padding: 20px;
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.title {
  font-size: 18px;
  font-weight: bold;
}
.icon-uploader {
  display: inline-block;
}
.icon-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
}
.icon-uploader-icon:hover {
  border-color: #409EFF;
}
.icon-preview {
  width: 100px;
  height: 100px;
  display: block;
  border-radius: 6px;
  object-fit: cover;
}

/* 标签页内容区域固定高度并滚动 */
.tab-content {
  max-height: 550px;
  overflow-y: auto;
  padding-right: 10px;
}

/* 美化滚动条 */
.tab-content::-webkit-scrollbar {
  width: 8px;
}

.tab-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.tab-content::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.tab-content::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>

<style>
/* 全局样式：调整对话框body的padding */
.college-dialog .el-dialog__body {
  padding: 20px 20px 20px 20px;
}
</style>
